import "./Loader.scss";
import { FC } from "react";

interface Props {
	initial?: boolean
}

const Loader: FC<Props> = (props: Props) => {
	return (
		<div className={`loading-modal ${props.initial ? 'full-screen' : ''}`}>
			<div className="loading-bubble-wrapper">
				<div className="data-loading-animation">
					<div className="bubble_1 bubble"/>
					<div className="bubble_2 bubble"/>
					<div className="bubble_3 bubble"/>
				</div>
				<p>Loading... Please wait</p>
			</div>
		</div>
	);
}

export default Loader;
